// extracted by mini-css-extract-plugin
export var cardIcon = "_5v-5";
export var checkboxCard = "_5v-0";
export var checkboxCardSelected = "_5v-4";
export var disabled = "_5v-2";
export var interactive = "_5v-1";
export var outerBorder = "_5v-3";
export var spacerMedium = "_5v-8";
export var spacerSmall = "_5v-7";
export var spacerXsmall = "_5v-6";